import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceInformationComponent } from './service-information.component';
import { ButtonModule } from '@lib/components';
import { DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { AirportNamePipeModule } from '../../pipes/airport-name/airport-name.module';

@NgModule({
  declarations: [ServiceInformationComponent],
  imports: [CommonModule, ButtonModule, StaticMsgModule, DateFormatModule, AirportNamePipeModule],
  exports: [ServiceInformationComponent],
})
export class ServiceInformationModule {}
